import { render, staticRenderFns } from "./desc-list.vue?vue&type=template&id=11e7ffc0&scoped=true&"
import script from "./desc-list.vue?vue&type=script&lang=js&"
export * from "./desc-list.vue?vue&type=script&lang=js&"
import style0 from "./desc-list.vue?vue&type=style&index=0&id=11e7ffc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e7ffc0",
  null
  
)

export default component.exports